import apiClient from '@/api/apiClient.js';
import { getPatPatientsId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    modelForm: {},
    statusPat: '',
    statusDel: '',
  },

  getters: { 
    schema(state) {
      return state.schema;
    },
    modelForm(state) {
      return state.modelForm;
    },
    statusPat(state) {
      return state.statusPat;
    },
    statusDel(state) {
      return state.statusDel;
    },
  },

  mutations: {
    insertSchema(state, schema) {
      state.schema = schema;
    },
    insertModelForm(state, modelForm) {
      state.modelForm = modelForm;
    },
    passSuccess(state, codeVerifMatch) {
      state.statusPat = codeVerifMatch;
    },
    passError(state) {
      state.statusPat = 'error';
    },
    sendCodeSuccess(state, codeVerifGen) {
      state.statusPat = codeVerifGen;
    },
    sendCodeError(state) {
      state.statusPat = 'error';
    },
    delSuccess(state, codeVerifMatch) {
      state.statusDel = codeVerifMatch;
    },
    delError(state) {
      state.statusPat = 'error';
    },
  },

  actions: {
    async loadSchema({ commit }) {
      try {
        const res = await apiClient.patAccountSchema();
        const schema = res.data;
        commit('insertSchema', schema);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async loadModelForm({ commit }, payload) {
      try {
        const id = getPatPatientsId();

        let model = {};
        if (payload === undefined) {
          model.usersPin = false;
        } else {
          const usersPin = payload.usersPin;
          model.usersPin = usersPin;
        }

        const res = await apiClient.patAccountPatient(id, model);
        const modelForm = res.data.data;
        commit('insertModelForm', modelForm);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async passAccount({ commit }, payload) {
      try {
        const id = getPatPatientsId();

        let model = {};
        if (payload === undefined) {
          model.usersCodeVerif = false;
        } else {
          model = payload.model;
          model.type = 'Pat';
        }

        const res = await apiClient.usersPass(id, model);
        const codeVerifMatch = res.data.data.codeVerifMatch;
        commit('passSuccess', codeVerifMatch);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error removiendo');
        commit('passError');
        throw error;
      }
    },
    async reSendCode({ commit }, payload) {
      try {
        const id = getPatPatientsId();

        let model = {};
        if (payload === undefined) {
          model.usersCodeVerif = false;
        } else {
          model = payload.model;
          model.type = 'Pat';
        }
        model.id = id;

        const res = await apiClient.usersCodeVerifGen(model);
        const codeVerifGen = res.data.data.codeVerifGen;
        commit('sendCodeSuccess', codeVerifGen);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error reenviando');
        commit('sendCodeError');
        throw error;
      }
    },
    async delAccount({ commit }, payload) {
      try {
        const id = getPatPatientsId();

        let model = {};
        if (payload === undefined) {
          model.usersCodeVerif = false;
        } else {
          model = payload.model;
          model.type = 'Pat';
        }

        
        const res = await apiClient.usersDelAccount(id, model);
        const codeVerifMatch = res.data.data.codeVerifMatch;
        commit('delSuccess', codeVerifMatch);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error removiendo');
        commit('delError');
        throw error;
      }
    },
  },
};
